export const MAPBOX_TOKEN =
  "pk.eyJ1IjoiZ3NkcG0iLCJhIjoiY2w1OW9veHYwMHExcjNqb2piZHRocTV2ZSJ9.FYnzyTjVusMd70ilxnHUDQ";

export const MAPBOX_STYLE = "mapbox://styles/gsdpm/cioenuwii001maznontujohu8";
